export function VendorInvoicePriceAdjustmentCtrl ($filter, $uibModalInstance, $scope, $translate, confirm, messages, workshopAPI, item, product, vendor_invoice) {
  $scope.item           = item;
  $scope.product        = product;
  $scope.vendor_invoice = vendor_invoice;

  $scope.newCost = $scope.vendor_invoice.invoice.price_includes_tax ? $scope.item.cost_including_tax : $scope.item.unit_cost
  $scope.oldCost = $scope.vendor_invoice.invoice.price_includes_tax ? $scope.product.cost_including_tax : $scope.product.cost

  $scope.getDifference = function () {
    workshopAPI.post('/product/calculate_difference_percentage', {
      new_cost: $scope.newCost.toString(),
      old_cost: $scope.oldCost.toString()
    }).then(function (data) {
      $scope.difference = data.toString() + '%';
    }, function (err) {
      messages.error(err);
    });
  }

  $scope.calculateMarkup = function () {
    if ($scope.newRetail) {
      $scope.markup = parseFloat(((($scope.newRetail - $scope.newCost) / $scope.newCost) * 100).toFixed(2));
      $scope.formatNewRetailPrice();
    } else {
      $scope.markup = null;
      $scope.newRetailFormatted = null;
    }
  }

  $scope.formatNewRetailPrice = function () {
    $scope.newRetailFormatted = $filter('globalCurrency')($scope.newRetail);
  }

  $scope.calculateNewRetail = function () {
    if ($scope.markup) {
      workshopAPI.post('/products/calculate_new_sell_price', {
        cost: ($scope.newCost).toString(),
        markup: $scope.markup
      }).then(function (data) {
        $scope.newRetail = data;
        $scope.formatNewRetailPrice();
      });
    } else {
      $scope.newRetail = null;
      $scope.newRetailFormatted = null;
    }
  }

  $scope.save = function () {
    confirm.generic($translate.instant('JS_SPACE.CONFIRM.UPDATE_RETAIL_PRICE_FOR_PRODUCT', {code:$scope.item.item_code}))
      .then(function () {
        return workshopAPI.post('/product/update_retail_price', {
          product_id: $scope.item.product_id,
          new_price: $scope.newRetail
        });
      }).then(function (data) {
        $uibModalInstance.close(data)
      }, function (err) {
        messages.error(err);
      });
  }

  $scope.getDifference();
}